module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-profile-0835108ac19f82aef359a59b0c0a6564.svg";